import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import Services from './pages/Services';
import Bookings from './pages/Bookings';
import Settings from './pages/Settings';
import Blogs from './pages/Blogs';
import Events from './pages/Events';
import BlogForm from './pages/BlogForm';
import EventForm from './pages/EventForm';
import Modalities from './pages/Modalities';
import ModalityForm from './pages/ModalityForm';
import MainQuestionnaire from './pages/MainQuestionnaire';
import MainQuestionnaireForm from './pages/MainQuestionnaireForm';
import UpdateHealerProfile from './pages/UpdateHealerProfile';

const RoutesConfig = () => {
  return(
    <Router>
      <Routes>
        <Route path='/sign-in' element={ <SignIn /> } />
        <Route path='/' element={ <Home /> } />
        <Route path='/services' element={ <Services /> } />
        <Route path='/bookings' element={ <Bookings /> } />
        <Route path='/blogs' element={ <Blogs /> } />
        <Route path='/add-blog' element={ <BlogForm /> } />
        <Route path='/edit-blog/:id' element={ <BlogForm /> } />
        <Route path='/events' element={ <Events /> } />
        <Route path='/add-event' element={ <EventForm /> } />
        <Route path='/edit-event/:id' element={ <EventForm /> } />
        <Route path='/modalities' element={ <Modalities /> } />
        <Route path='/add-modality' element={ <ModalityForm /> } />
        <Route path='/edit-modality/:id' element={ <ModalityForm /> } />
        <Route path='/main-questionnaire' element={ <MainQuestionnaire /> } />
        <Route path='/main-questionnaire/add' element={ <MainQuestionnaireForm /> } />
        <Route path='/main-questionnaire/edit/:id' element={ <MainQuestionnaireForm /> } />
        <Route path='/settings' element={ <Settings /> } />
        <Route path='/edit-profile/:id' element={ <UpdateHealerProfile /> } />
      </Routes>
    </Router>
  )
}

export default RoutesConfig;